module.exports = __webpack_public_path__ + "static/statistics_img@2x.541081d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/engagement/statistics_img@2x.png
// module id = 682
// module chunks = 193162123475590